var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgBlackThumpUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.458 5.082h3.117a.46.46 0 0 1 .458.46v6.095a.46.46 0 0 1-.458.46H.458a.46.46 0 0 1-.458-.46V5.541a.46.46 0 0 1 .458-.46ZM7.184.509c.242-1.225 2.247-.097 2.38 1.877.04.604-.023 1.307-.172 2.092h2.866c1.192.047 2.232.9 1.497 2.302.167.61.192 1.327-.262 1.61.057.963-.21 1.56-.709 2.032-.033.482-.135.91-.368 1.24-.385.543-.697.413-1.303.413H6.274c-.767 0-1.185-.21-1.686-.84V5.846c1.442-.39 2.21-2.363 2.596-3.658V.508Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackThumpUp);
export default __webpack_public_path__ + "static/media/black-thump-up.226805d1a793b9edc74f42e52c802461.svg";
export { ForwardRef as ReactComponent };